<template>
  <div class="performance-report-detail">
    <div class="header">履约报表详情</div>
    <div class="content">
      <!-- 基础信息 -->
      <div class="detail basic-msg">
        <div class="header">基础信息</div>
        <div class="content">
          <el-table
            tooltip-effect="dark"
            border
            style="width: 100%"
            :data="resData.list"
          >
            <el-table-column
              align="center"
              prop="str_demanded_date"
              label="需求日期"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="supply_id"
              label="商家ID"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="str_supply"
              label="商家"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              align="center"
              prop="str_market"
              label="市场"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              align="center"
              prop="str_pg_group"
              label="代采组"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              align="center"
              prop="str_pg_member"
              label="代采员"
            ></el-table-column>
          </el-table>
        </div>
      </div>
      <!-- 报表汇总 （数量/金额） -->
      <div class="detail amount">
        <div class="header">
          报表汇总
          <span style="color: #4e9fe8">
            （数量/金额，金额按计划代采单统计）
          </span>
        </div>
        <div class="content">
          <el-table
            tooltip-effect="dark"
            border
            style="width: 100%"
            :data="resData.list"
          >
            <el-table-column
              align="center"
              prop="24h_performance_rate"
              label="24H履约率"
            >
              <template #header>
                <el-tooltip class="item" effect="dark" placement="top">
                  <div style="position: relative">
                    24H履约率<i class="el-icon-question" />
                  </div>
                  <div slot="content">
                    <div>24H履约率 = 24H已履约金额 / 总需求金额</div>
                    <div>24H：履约时间-需求日期 7:00 ≤ 24H</div>
                  </div>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                <div>
                  <div>
                    {{ scope.row["24h_performance_rate"] }}
                  </div>
                  <div style="color: #ccc">
                    {{ scope.row["24h_generate_status"] }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="48h_performance_rate"
              label="48H履约率"
            >
              <template #header>
                <el-tooltip class="item" effect="dark" placement="top">
                  <div style="position: relative">
                    48H履约率<i class="el-icon-question" />
                  </div>
                  <div slot="content">
                    <div>48H履约率 = 48H已履约金额 / 总需求金额</div>
                    <div>48H：履约时间-需求日期 7:00 ≤ 48H</div>
                  </div>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                <div>
                  <div>
                    {{ scope.row["48h_performance_rate"] }}
                  </div>
                  <div style="color: #ccc">
                    {{ scope.row["48h_generate_status"] }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="final_performance_rate"
              label="最终履约率"
            >
              <template #header>
                <el-tooltip class="item" effect="dark" placement="top">
                  <div style="position: relative">
                    最终履约率<i class="el-icon-question" />
                  </div>
                  <div slot="content">
                    <div>最终履约率 = 最终已履约金额 / 总需求金额</div>
                    <div>春夏（3月~9月）：履约时间 - 需求日期 7:00 ≤ 10天</div>
                    <div>秋冬（10月~2月）：履约时间 - 需求日期 7:00 ≤ 15天</div>
                  </div>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                <div>
                  <div>
                    {{ scope.row["final_performance_rate"] }}
                  </div>
                  <div style="color: #ccc">
                    {{ scope.row["final_generate_status"] }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column align="center" label="总需求">
              <el-table-column
                align="center"
                prop="str_all_pre"
                label="前置仓发货"
              >
                <template #header>
                  <el-tooltip class="item" effect="dark" placement="top">
                    <div style="position: relative">
                      前置仓发货<i class="el-icon-question" />
                    </div>
                    <div slot="content">
                      统计前一天6:00至当天6:00由前置仓发货的商品，包含发货出库、售后寄出和前置仓异常出库（即前置仓买赔）
                    </div>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="str_all_plan"
                label="订货单计划代采"
              >
                <template #header>
                  <el-tooltip class="item" effect="dark" placement="top">
                    <div style="position: relative">
                      订货单计划代采<i class="el-icon-question" />
                    </div>
                    <div slot="content">
                      统计对应需求时间的代采计划中，总计划代采的商品数据。不含提前代采计划
                    </div>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column align="center" prop="str_all_sum" label="小计">
                <template #header>
                  <el-tooltip class="item" effect="dark" placement="top">
                    <div style="position: relative">
                      小计<i class="el-icon-question" />
                    </div>
                    <div slot="content">
                      总需求 = 前置仓发货 + 订货单计划代采
                    </div>
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column
              align="center"
              label="已履约"
              label-class-name="performance"
            >
              <el-table-column
                align="center"
                prop="str_done_pre"
                label="前置仓发货"
                label-class-name="performance"
              >
                <template #header>
                  <el-tooltip class="item" effect="dark" placement="top">
                    <div style="position: relative">
                      前置仓发货<i class="el-icon-question" />
                    </div>
                    <div slot="content">
                      统计前一天6:00至当天6:00由前置仓发货的商品，包含发货出库、售后寄出和前置仓异常出库（即前置仓买赔）
                    </div>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="str_done_plan"
                label="订货单正常品已入库（含坏账）"
                label-class-name="performance"
              >
                <template #header>
                  <el-tooltip class="item" effect="dark" placement="top">
                    <div style="position: relative">
                      订货单正常品已入库（含坏账）<i class="el-icon-question" />
                    </div>
                    <div slot="content">
                      统计对应需求时间的代采计划，开单后售前首次以正常品入库 或
                      首次申请为坏账时计入。
                      ①恢复欠货/正常品入库后调拨为不良品/坏账驳回均不再扣除。
                      ②已计入履约的，不再重复计算。
                      ③履约时间：代采欠货正常品入库-取生成包裹时间；退换货欠货正常品入库
                      -取入库时间；申请坏账 - 申请坏账时间
                    </div>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="str_done_sum"
                label="小计"
                label-class-name="performance"
              >
                <template #header>
                  <el-tooltip class="item" effect="dark" placement="top">
                    <div style="position: relative">
                      小计<i class="el-icon-question" />
                    </div>
                    <div slot="content">
                      已履约 = 前置仓发货 + 订货单正常品已入库（含坏账）
                    </div>
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column
              align="center"
              label="待履约"
              label-class-name="await-performance"
            >
              <el-table-column
                align="center"
                prop="str_doing_plan"
                label="待开单"
                label-class-name="await-performance"
              >
                <template #header>
                  <el-tooltip class="item" effect="dark" placement="top">
                    <div style="position: relative">
                      待开单<i class="el-icon-question" />
                    </div>
                    <div slot="content">
                      统计对应需求时间的代采计划当前在待开单的商品数据。
                    </div>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="str_doing_owe"
                label="订单欠货"
                label-class-name="await-performance"
              >
                <template #header>
                  <el-tooltip class="item" effect="dark" placement="top">
                    <div style="position: relative">
                      订单欠货<i class="el-icon-question" />
                    </div>
                    <div slot="content">
                      统计对应需求时间的代采计划当前在订单欠货（含由订单欠货转退款中）的商品数据。
                    </div>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="str_doing_on_way"
                label="配送在途"
                label-class-name="await-performance"
              >
                <template #header>
                  <el-tooltip class="item" effect="dark" placement="top">
                    <div style="position: relative">
                      配送在途<i class="el-icon-question" />
                    </div>
                    <div slot="content">
                      统计对应需求时间的代采计划当前在配送在途（即在途库存）、在途转欠货申请中的商品数据。
                    </div>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="str_doing_reject"
                label="退换货"
                label-class-name="await-performance"
              >
                <template #header>
                  <el-tooltip class="item" effect="dark" placement="top">
                    <div style="position: relative">
                      退换货<i class="el-icon-question" />
                    </div>
                    <div slot="content">
                      统计对应需求时间的代采计划当前为售前不良品在库、退换货待接收、退换货欠货、由售前退换货转退款中和转呆账的商品数据。
                    </div>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="str_doing_sum"
                label="小计"
                label-class-name="await-performance"
              >
                <template #header>
                  <el-tooltip class="item" effect="dark" placement="top">
                    <div style="position: relative">
                      小计<i class="el-icon-question" />
                    </div>
                    <div slot="content">
                      待履约 = 待开单 + 订单欠货 + 配送在途 + 退换货
                    </div>
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column
              align="center"
              label="未履约"
              label-class-name="default"
            >
              <el-table-column
                align="center"
                prop="str_yet_stopped"
                label="已断货"
                label-class-name="default"
              >
                <template #header>
                  <el-tooltip class="item" effect="dark" placement="top">
                    <div style="position: relative">
                      已断货<i class="el-icon-question" />
                    </div>
                    <div slot="content">
                      统计对应需求时间的代采计划当前已断货的商品数据。
                    </div>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="str_yet_ded"
                label="转抵扣"
                label-class-name="default"
              >
                <template #header>
                  <el-tooltip class="item" effect="dark" placement="top">
                    <div style="position: relative">
                      转抵扣<i class="el-icon-question" />
                    </div>
                    <div slot="content">
                      统计对应需求时间的代采计划当前已转抵扣（含待抵扣、已抵扣、待抵扣转退款中）的商品数据。
                    </div>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="str_yet_refund"
                label="已退款"
                label-class-name="default"
              >
                <template #header>
                  <el-tooltip class="item" effect="dark" placement="top">
                    <div style="position: relative">
                      已退款<i class="el-icon-question" />
                    </div>
                    <div slot="content">
                      统计对应需求时间的代采计划当前已完成退款的商品数据。
                    </div>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="str_yet_sum"
                label="小计"
                label-class-name="default"
              >
                <template #header>
                  <el-tooltip class="item" effect="dark" placement="top">
                    <div style="position: relative">
                      小计<i class="el-icon-question" />
                    </div>
                    <div slot="content">未履约 = 已断货 + 转抵扣 + 已退款</div>
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <!-- 商品明细 -->
      <div class="detail amount">
        <div class="header">商品明细</div>
        <div class="content">
          <el-tabs
            v-model="activeName"
            :stretch="true"
            @tab-click="handleClickTag"
          >
            <el-tab-pane
              v-for="item in resData.options_report_detail_type"
              :key="item.value"
              :label="item.label"
              :name="item.value"
            >
            </el-tab-pane>
          </el-tabs>
          <YsDataTable
            ref="tableRef"
            v-model="refresh"
            :init-params="initParams"
            :list="searchList"
            :dep-option-map="optionsMap"
            :columns="columns"
            :fetch-method="fetchMethod"
            page-size-alias="page_size"
            :button-list="buttonList"
            use-data-field
            @on-change="getSearchParams"
            @on-fetch-success="handleFetchSuccess"
          >
            <template #table-title>
              <div class="header">
                数据列表 共{{ goodsDetailAmount.sum_num }}件，计￥{{
                  goodsDetailAmount.sum_price
                }}元
              </div>
            </template>
            <template #goods_img="{ row }">
              <div class="goods-img" @click="handleViewImages([row.goods_img])">
                <img
                  :src="row.goods_img"
                  style="max-width: 100%; max-height: 100%; object-fit: cover"
                />
              </div>
            </template>
            <template #wcgPlan="{ row }">
              <div class="wcg-plan">
                <span class="wcg_plan_id">
                  {{ row.planid }}
                </span>
                <span class="ptype">
                  {{ row.ptype }}
                  <span v-if="row.is_dispense" style="color: #479ce8">
                    （ 小店分发）
                  </span>
                </span>
                <span class="effect-time">
                  {{ row.effect_time }}
                </span>
              </div>
            </template>
            <template #wcgOrder="{ row }">
              <div class="wcg-plan">
                <span class="woid">
                  {{ row.woid }}
                </span>
                <span class="wcg-sub-time">
                  {{ row.wcg_sub_time }}
                </span>
              </div>
            </template>
          </YsDataTable>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  postReportDetailSummary,
  postReportGoodsDetail,
} from "@/openapi/erp/performanceReport.js";
import apiBaseURL from "@/utils/baseUrl.js";

// 商品明细搜索列表以及cloumns
const searchListWrap = {
  // 前置仓发货
  tab1: [
    {
      tag: "input",
      label: "款号",
      field: "goods_kh_like",
    },
    {
      tag: "input",
      label: "货号",
      field: "goods_no",
    },
    {
      tag: "input",
      label: "SKU编码",
      field: "sku",
    },
  ],
  // 订货单计划代采 待开单 已断货
  tab2: [
    {
      tag: "input",
      label: "款号",
      field: "goods_kh_like",
    },
    {
      tag: "input",
      label: "货号",
      field: "goods_no",
    },
    {
      tag: "input",
      label: "SKU编码",
      field: "sku",
    },
    {
      tag: "input",
      label: "代采计划单号",
      field: "plan_id",
    },
  ],
  // 订货单正常品已入库（含坏账） 订单欠货 配送在途 退换货 转抵扣  已退款
  tab3: [
    {
      tag: "input",
      label: "款号",
      field: "goods_kh_like",
    },
    {
      tag: "input",
      label: "货号",
      field: "goods_no",
    },
    {
      tag: "input",
      label: "SKU编码",
      field: "sku",
    },
    {
      tag: "input",
      label: "代采计划单号",
      field: "plan_id",
    },
    {
      tag: "input",
      label: "代采单号",
      field: "order_id",
    },
    {
      tag: "select",
      label: "来源",
      field: "source",
      optionsField: "options_source",
    },
  ],
};
const generateColumns = [
  {
    label: "商品名称",
    prop: "goods_name",
  },
  {
    label: "款号",
    prop: "goods_kh",
  },
  {
    label: "货号",
    prop: "goods_no",
  },
  {
    label: "SKU编码",
    prop: "sku",
  },
  {
    label: "颜色",
    prop: "co_val",
  },
  {
    label: "尺码",
    prop: "si_val",
  },
  {
    label: "计划代采单价",
    prop: "plan_price",
  },
  {
    label: "代采单价",
    prop: "price",
  },
  {
    label: "数量",
    prop: "num",
  },
];
const columnsWrap = {
  // 前置仓发货
  columns1: [
    {
      label: "图片",
      slot: "goods_img",
      width: 120,
    },
    {
      label: "商品名称",
      prop: "goods_name",
    },
    {
      label: "款号",
      prop: "goods_kh",
    },
    {
      label: "货号",
      prop: "goods_no",
    },
    {
      label: "SKU编码",
      prop: "sku",
    },
    {
      label: "颜色",
      prop: "co_val",
    },
    {
      label: "尺码",
      prop: "si_val",
    },
    {
      label: "代采单价",
      prop: "price",
    },
    {
      label: "数量",
      prop: "num",
    },
    {
      label: "波次单号",
      prop: "wave_picking_no",
    },
    {
      label: "出库类型",
      prop: "str_out_type",
    },
    {
      label: "出库时间",
      prop: "out_stock_time",
    },
  ],
  // 订货单计划代采、待开单
  columns2: [
    {
      label: "代采计划/生效时间",
      slot: "wcgPlan",
    },
    {
      label: "需求时间",
      prop: "demanded_date",
    },
    {
      label: "图片",
      slot: "goods_img",
      width: 120,
    },
    {
      label: "商品名称",
      prop: "goods_name",
    },
    {
      label: "款号",
      prop: "goods_kh",
    },
    {
      label: "货号",
      prop: "goods_no",
    },
    {
      label: "SKU编码",
      prop: "sku",
    },
    {
      label: "颜色",
      prop: "co_val",
    },
    {
      label: "尺码",
      prop: "si_val",
    },
    {
      label: "计划代采单价",
      prop: "plan_price",
    },
    {
      label: "数量",
      prop: "num",
    },
  ],
  // 订货单正常品已入库（含坏账）
  columns3: [
    {
      label: "代采计划/生效时间",
      slot: "wcgPlan",
    },
    {
      label: "图片",
      slot: "goods_img",
      width: 120,
    },
    ...generateColumns,
    {
      label: "代采订单/提交时间",
      slot: "wcgOrder",
    },
    {
      label: "来源",
      prop: "source",
    },
    {
      label: "履约状态",
      prop: "performance_status",
    },
    {
      label: "履约时间",
      prop: "performance_time",
    },
  ],
  //  订单欠货 配送在途 退换货
  columns4: [
    {
      label: "代采计划/生效时间",
      slot: "wcgPlan",
    },
    {
      label: "图片",
      slot: "goods_img",
      width: 120,
    },
    ...generateColumns,
    {
      label: "代采订单/提交时间",
      slot: "wcgOrder",
    },
    {
      label: "来源",
      prop: "source",
    },
    {
      label: "状态",
      prop: "status",
    },
    {
      label: "操作时间",
      prop: "operate_time",
    },
  ],
  // 已断货
  columns5: [
    {
      label: "代采计划/生效时间",
      slot: "wcgPlan",
    },
    {
      label: "图片",
      slot: "goods_img",
      width: 120,
    },
    {
      label: "商品名称",
      prop: "goods_name",
    },
    {
      label: "款号",
      prop: "goods_kh",
    },
    {
      label: "货号",
      prop: "goods_no",
    },
    {
      label: "SKU编码",
      prop: "sku",
    },
    {
      label: "颜色",
      prop: "co_val",
    },
    {
      label: "尺码",
      prop: "si_val",
    },
    {
      label: "计划代采单价",
      prop: "plan_price",
    },
    {
      label: "数量",
      prop: "num",
    },
    {
      label: "断货类型",
      prop: "stop_type",
    },
    {
      label: "断货时间",
      prop: "stop_time",
    },
  ],
  // 转抵扣
  columns6: [
    {
      label: "代采计划/生效时间",
      slot: "wcgPlan",
    },
    {
      label: "图片",
      slot: "goods_img",
      width: 120,
    },
    {
      label: "商品名称",
      prop: "goods_name",
    },
    ...generateColumns,
    {
      label: "代采订单/提交时间",
      slot: "wcgOrder",
    },
    {
      label: "来源",
      prop: "source",
    },
    {
      label: "抵扣金额",
      prop: "ded_price",
    },
    {
      label: "状态",
      prop: "status",
    },
    {
      label: "操作时间",
      prop: "operate_time",
    },
  ],
  // 已退款
  columns7: [
    {
      label: "代采计划/生效时间",
      slot: "wcgPlan",
    },
    {
      label: "图片",
      slot: "goods_img",
      width: 120,
    },
    ...generateColumns,
    {
      label: "代采订单/提交时间",
      slot: "wcgOrder",
    },
    {
      label: "来源",
      prop: "source",
    },
    {
      label: "退款金额",
      prop: "refund_price",
    },
    {
      label: "状态",
      prop: "status",
    },
    {
      label: "退款提交时间",
      prop: "refund_submit_time",
    },
  ],
};

export default {
  name: "PerformanceReportDetail",
  data() {
    return {
      queryData: null,
      resData: { options_report_detail_type: [] },
      activeName: "1",
      goodsDetailAmount: {
        sum_num: 0,
        sum_price: 0.0,
      },
      refresh: false,
      fetchMethod: postReportGoodsDetail,
      searchList: searchListWrap.tab1,
      buttonList: [
        {
          tag: "button",
          text: "导出",
          props: {
            type: "success",
          },
          event: {
            handler: this.exportGoodsDetail,
          },
        },
      ],
      optionsMap: {},
      columns: columnsWrap.columns1,
      searchParams: {},
    };
  },
  computed: {
    initParams() {
      return {
        ...this.queryData,
        ...this.searchParams,
        detail_type: this.activeName,
      };
    },
  },
  watch: {
    activeName(value) {
      // 不同的tab显示不同的搜索项和展示列表
      switch (value) {
        // 前置仓发货
        case "1":
          this.searchList = searchListWrap.tab1;
          this.columns = columnsWrap.columns1;
          break;
        // 订货单计划代采
        case "2":
        case "4": // 待开单
          this.searchList = searchListWrap.tab2;
          this.columns = columnsWrap.columns2;
          break;
        // 订货单正常品已入库（含坏账）
        case "3":
          this.searchList = searchListWrap.tab3;
          this.columns = columnsWrap.columns3;
          break;
        // 订单欠货
        case "5":
        case "6": // 配送在途
        case "7": // 退换货
          this.searchList = searchListWrap.tab3;
          this.columns = columnsWrap.columns4;
          break;
        // 已断货
        case "8":
          this.searchList = searchListWrap.tab2;
          this.columns = columnsWrap.columns5;
          break;
        // 转抵扣
        case "9":
          this.searchList = searchListWrap.tab3;
          this.columns = columnsWrap.columns6;
          break;
        // 已退款
        case "10":
          this.searchList = searchListWrap.tab3;
          this.columns = columnsWrap.columns7;
          break;
        // 默认tab1
        default:
          this.searchList = searchListWrap.tab1;
          this.columns = columnsWrap.columns1;
          break;
      }
    },
  },
  created() {
    const { supply_id: supplyId, demanded_date: demandedDate } =
      this.$route.query;

    this.queryData = {
      supply_id: supplyId,
      demanded_date: demandedDate,
    };
    this.fetchData();
  },
  methods: {
    fetchData() {
      postReportDetailSummary(this.queryData).then((res) => {
        const { options_source: optionsSource, ...rest } = res;
        this.resData = rest;
        this.optionsMap = { options_source: optionsSource };
        // 获取商品明细数据
        this.refresh = true;
      });
    },
    // 切换tag
    handleClickTag(tag) {
      const { name } = tag;
      this.activeName = name;
      // 清空分页选项
      this.$refs.tableRef.initPageValue();
      this.refresh = true;
    },
    // 请求商品明细成功
    handleFetchSuccess(res) {
      const { sum_num: sumNum, sum_price: sumPrice } = res;
      this.goodsDetailAmount = {
        sum_num: sumNum,
        sum_price: sumPrice,
      };
    },
    // 搜索参数
    getSearchParams(params) {
      this.searchParams = params;
    },
    // 显示图片
    handleViewImages(images) {
      this.$viewerApi({
        images,
      });
    },
    // 导出商品明细列表
    exportGoodsDetail() {
      postReportGoodsDetail({
        ...this.initParams,
        is_export: 1,
      })
        .then((res) => {
          const { file } = res;
          window.open(apiBaseURL + file);
        })
        .catch(this.$noop);
    },
  },
};
</script>

<style scoped lang="less">
.performance-report-detail {
  position: relative;
}
.detail {
  position: relative;
  margin-top: 12px;
  .header {
    background: #f3f3f3;
    height: 40px;
    line-height: 40px;
    padding: 0 25px;
    display: flex;
    align-items: center;
    position: relative;
  }
  .content {
    .wcg-plan {
      display: flex;
      flex-direction: column;
    }
  }
  .goods-img {
    height: 80px;
    width: 80px;
    cursor: pointer;
    margin: 0 auto;
  }
}
/deep/ .el-table .el-table__cell.performance {
  background: #aeebcf;
}
/deep/ .el-table .el-table__cell.await-performance {
  background: #bed3fc;
}
/deep/ .el-table .el-table__cell.default {
  background: #f0c98c;
}
</style>



// WEBPACK FOOTER //
// src/pages/PerformanceReport/PerformanceReportDetail.vue